import {
  Progress as MantineProgress,
  type ProgressProps as MantineProgressProps,
} from "@mantine/core"

const LINE_PROGRESS_TRANSITION_MS = 1200

export type LineProgressProps = {
  value: number
  animated?: boolean
} & Omit<MantineProgressProps, "value">

export const LineProgress = ({
  value,
  animated = false,
  size = "xs",
  radius = "xs",
  color = "var(--progress-bar-color-filled)",
  styles,
  ...props
}: LineProgressProps) => {
  const tokenStyles = {
    root: {
      backgroundColor: "var(--progress-bar-color-unfilled)",
    },
    section: animated
      ? {
          transition: `width ${LINE_PROGRESS_TRANSITION_MS}ms linear`,
        }
      : undefined,
  }

  return (
    <MantineProgress
      {...props}
      value={value}
      size={size}
      radius={radius}
      color={color}
      styles={styles ?? tokenStyles}
    />
  )
}
